import { useMutation, useQuery } from 'urql';
import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import {
  SignUpFormElementsQuery,
  UpdateSignUpFormElementsMutation,
} from './SignUpFormPage.tsx';
import { SignUpFormElementForm } from './SignUpFormElementForm.tsx';
import { SignUpCustomFieldInput } from '../../gql/graphql.ts';
import { cloneAndRemoveTypename } from '../../public/util.ts';

interface SignUpFormElementNewProps {
  companyId: string;
  formId: string;
}

export const SignUpFormElementNewPage: React.FC<SignUpFormElementNewProps> = ({
  companyId,
  formId,
}) => {
  const [{ data }] = useQuery({
    query: SignUpFormElementsQuery,
    variables: { companyId, formId },
    pause: companyId === undefined || companyId === null,
  });
  const [, updateSignUpForm] = useMutation(UpdateSignUpFormElementsMutation);
  const navigate = useNavigate();

  const onFormSubmit = (value: SignUpCustomFieldInput) => {
    if (data?.companySignUpCustomFields) {
      updateSignUpForm({
        companyId,
        formId,
        signUpFormElements: cloneAndRemoveTypename([
          ...data.companySignUpCustomFields,
          value,
        ]),
      }).then(() => {
        navigate({
          to: '/admin/sign-up-forms/$formId',
          params: { formId },
        });
      });
    }
  };

  return (
    <SignUpFormElementForm
      value={{
        required: false,
        systemField: false,
        options: [],
        name: '',
        showAfter: false,
        showInMail: false,
      }}
      onSubmit={(s) => onFormSubmit(s)}
      allFields={
        data ? cloneAndRemoveTypename(data.companySignUpCustomFields) : []
      }
      backHref={`/admin/sign-up-forms/${formId}`}
    />
  );
};
